export default () => {
  const sidebar = document.querySelector('.sticky-sidebar');
  const stickyTopEl = document.querySelector('.sticky-top-el');
  const productContent = document.querySelector('.product-list-content');

  if(!sidebar || !stickyTopEl) {
    return;
  }

  const docElem = document.documentElement;
  let offset;
  let pos;
  let sidebarWidth;
  let offsetBottom;
  let didScroll = false;

  const init = () => {
    let sidebarRect = sidebar.getBoundingClientRect();
    offset = stickyTopEl.getBoundingClientRect().bottom;
    pos = sidebarRect.top + window.scrollY - offset;
    sidebarWidth = sidebarRect.width;
    if(productContent) {
      offsetBottom = window.scrollY + productContent.getBoundingClientRect().bottom;
    }
  }


  const scrollPage = () => {

    if ( window.scrollY >= pos && ( undefined === offsetBottom || offsetBottom > window.scrollY + window.innerHeight - 20 )) {
      sidebar.classList.add('sticky-sidebar-fixed');
      sidebar.style.top = `${offset}px`;
      sidebar.style.width = `${sidebarWidth}px`;
    } else {
      sidebar.classList.remove('sticky-sidebar-fixed');
      sidebar.removeAttribute('style');
    }

    didScroll = false;
  }

  window.addEventListener('scroll', () => {
    if ( !didScroll ) {
      didScroll = true;
      scrollPage();
    }
  });

  window.addEventListener('resize', scrollPage);

  document.body.addEventListener('products_loaded', () => {
    init();
    scrollPage();
  });

  init();
  scrollPage();

}
